import { Button, Modal } from "react-bootstrap";
import {
  delete_patient_evolution,
  load_patient_fichas_list,
  modify_patient_evolution,
  upload_patient_evolution,
} from "../../actions/clinic_content";
import { useEffect, useState } from "react";
import { checkAuthenticated } from "../../actions/auth";
import { useDispatch } from "react-redux";

const EvolutionModal = (props) => {
  const dispatch = useDispatch();
  const { show, onHide, patientId, loadedEvoData, loadedFichaList, onSuccess } = props;
  const [evoData, setEvoData] = useState({
    evo_code: "",
    clinic_patient: patientId,
    evolution_list: null,
    evo_date: "",
    evo_detail: "",
  });
  const [fichasOptions, setFichasOptions] = useState([]);
  const [apiError, setApiError] = useState(null);
  const [formAlerts, setFormAlerts] = useState({
    evo_date: false,
    evo_code: false,
    evo_detail: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEvoData({ ...evoData, [name]: value === "null" ? null : value });
  };

  const checkEmptyFields = (keyList) => {
    let hasEmpty = false;
    const newAlerts = { ...formAlerts };
    keyList.forEach((key) => {
      if (!evoData[key] || evoData[key].toString().trim() === "") {
        newAlerts[key] = true;
        hasEmpty = true;
      } else {
        newAlerts[key] = false;
      }
    });
    setFormAlerts(newAlerts);
    setTimeout(() => {
      setFormAlerts({ evo_date: false, evo_code: false, evo_detail: false });
    }, 3500);
    return hasEmpty;
  };

  const isEditing = loadedEvoData?.id != null;

  const handleSubmit = async () => {
    dispatch(checkAuthenticated());
    
    if (!checkEmptyFields(["evo_date", "evo_code", "evo_detail"])) {
      setApiError(null);
      try {
        let result;
        if (isEditing) {
          result = await modify_patient_evolution(
            patientId,
            loadedEvoData.id,
            evoData,
          );
        } else {
          result = await upload_patient_evolution(patientId, evoData);
        }

        if (result) {
          setEvoData({
            evo_code: "",
            clinic_patient: patientId,
            evolution_list: evoData.evolution_list,
            evo_date: "",
            evo_detail: "",
          });
          if (onSuccess) onSuccess();
          onHide();
        }
      } catch (err) {
        if (err.isAuthError) {
          setApiError(err.message);
        } else {
          setApiError("Ocurrió un error inesperado. Por favor, intente nuevamente.");
        }
      }
    }
  };

  const handleDelete = async (evoId) => {
    dispatch(checkAuthenticated());
    setApiError(null);
    try {
      const status = await delete_patient_evolution(patientId, evoId);
      if (status == 204) {
        setEvoData({
          evo_code: "",
          clinic_patient: patientId,
          evolution_list: evoData.evolution_list,
          evo_date: "",
          evo_detail: "",
        });
        if (onSuccess) onSuccess();
        onHide();
      }
    } catch (err) {
      if (err.isAuthError) {
        setApiError(err.message);
      } else {
        setApiError("Ocurrió un error inesperado. Por favor, intente nuevamente.");
      }
    }
  };

  useEffect(() => {
    // fetchOptions();

    if (loadedFichaList) {
      setFichasOptions(loadedFichaList);
    }
    if (loadedEvoData) {
      setEvoData({ ...loadedEvoData });
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="justify-content-center">
        <Modal.Title id="contained-modal-title-vcenter">
          {loadedEvoData?.id ? "Editar" : "Agregar"} Evolución
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          {/* Row: Date & Code */}
          <div className="d-flex gap-3">
            <div className="input-field flex-fill">
              <label htmlFor="evoDateInput" className="form-label mb-1">
                Fecha
                <strong className="text-danger">*</strong>
                <span
                  className={
                    formAlerts.evo_date
                      ? "fst-italic m-2 text-danger"
                      : "d-none"
                  }
                >
                  Requerido.
                </span>
              </label>
              <input
                type="date"
                id="evoDateInput"
                className={
                  formAlerts.evo_date
                    ? "border border-danger form-control"
                    : "form-control"
                }
                name="evo_date"
                value={evoData.evo_date}
                onChange={handleChange}
              />
            </div>

            <div className="input-field flex-fill">
              <label htmlFor="evoCodeInput" className="form-label mb-1">
                Código
                <strong className="text-danger">*</strong>
                <span
                  className={
                    formAlerts.evo_code
                      ? "fst-italic m-2 text-danger"
                      : "d-none"
                  }
                >
                  Requerido.
                </span>
              </label>
              <input
                type="text"
                id="evoCodeInput"
                className={
                  formAlerts.evo_code
                    ? "border border-danger form-control"
                    : "form-control"
                }
                name="evo_code"
                value={evoData.evo_code}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Ficha selector */}
          <div className="input-field">
            <label htmlFor="evoFichaSelect" className="form-label mb-1">
              Ficha
            </label>
            <select
              id="evoFichaSelect"
              className="form-select"
              name="evolution_list"
              value={evoData.evolution_list ?? "null"}
              onChange={handleChange}
            >
              <option value="null">Sin ficha</option>
              {fichasOptions.map((ficha) => (
                <option key={ficha.id} value={ficha.id}>
                  {ficha.evo_list_name}
                </option>
              ))}
            </select>
          </div>

          {/* Detail textarea */}
          <div className="input-field">
            <label htmlFor="evoDetailTextarea" className="form-label mb-1">
              Detalle
              <strong className="text-danger">*</strong>
              <span
                className={
                  formAlerts.evo_detail
                    ? "fst-italic m-2 text-danger"
                    : "d-none"
                }
              >
                Requerido.
              </span>
            </label>
            <textarea
              id="evoDetailTextarea"
              className={
                formAlerts.evo_detail
                  ? "border border-danger form-control"
                  : "form-control"
              }
              rows={5}
              name="evo_detail"
              value={evoData.evo_detail}
              onChange={handleChange}
            />
          </div>
        </div>
        {apiError && (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            {apiError}
            <button
              type="button"
              className="btn-close"
              onClick={() => setApiError(null)}
              aria-label="Close"
            ></button>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        {loadedEvoData?.id && (
          <div>
            <Button
              variant="outline-danger d-flex align-items-center gap-2"
              onClick={() => handleDelete(loadedEvoData.id)}
            >
              <i className="bi bi-trash" />
              Eliminar
            </Button>
          </div>
        )}
        <div className="d-flex flex-fill justify-content-end gap-2">
          <Button variant="secondary" onClick={onHide}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {loadedEvoData?.id ? "Guardar" : "Crear"} Evolución
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EvolutionModal;
